import { MetricType, forHumans } from "@madmedical/medical";
export const mapCoords = (measurements, { from, to }, mapper) => {
    const coords = measurements.map(({ measuredAt, metric, manual: isManual }) => (Object.assign({ x: 100, msec: new Date(measuredAt).getTime(), displayValue: metric.displayValue, isManual, note: metric.type === MetricType.BloodSugar
            ? forHumans(metric.mealSituation)
            : undefined }, mapper(metric))));
    coords.unshift({ x: 100, msec: from.getTime() });
    coords.push({ x: 100, msec: to.getTime() });
    return coords;
};
